export const excludedStatuses = ['BRK'];

export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const DEFAULT_PARAMS = {
  PageNumber: DEFAULT_PAGE_NUMBER,
  PageSize: DEFAULT_PAGE_SIZE,
};

// TODO: check this. Unused
export const TRANSACTION_TYPES = {
  Purchase: 'Purchase',
  Shipped: 'Shipped',
  Transfer: 'Transfer',
};

// IMS and Yard Locations for Supplier
export const SUPPLIER_REGION_KEYS = [5869, 5815, 5816];
